const COMPONENT_NAME = "LinkList";
const LANGUAGES_ENTRY_ID_DEV = "blt624af6512c48ec91";
const LANGUAGES_ENTRY_ID_CABC = "bltabf767465ab719f6";
const WITH_BACKGROUND_CLASS = "hasBackground";
const MODULE_SETTINGS_NAME = "language_selector";
export {
  COMPONENT_NAME,
  LANGUAGES_ENTRY_ID_CABC,
  LANGUAGES_ENTRY_ID_DEV,
  MODULE_SETTINGS_NAME,
  WITH_BACKGROUND_CLASS
};
